import { Controller } from '@hotwired/stimulus'

// Copies the sourceTarget's text to the clipboard on demand. The button flips to
// "Copied!" for a couple of seconds then reverts, and a visually-hidden
// role="status" target announces the result to screen readers (aria-live).
//
// Dependency-free: uses the native clipboard API only. Nothing here decides what
// is copyable — it just moves text the page already shows.
export default class extends Controller {
  static targets = ['source', 'button', 'status']

  disconnect() {
    clearTimeout(this.revert)
  }

  async copy() {
    const text = this.hasSourceTarget ? this.sourceTarget.textContent : ''

    try {
      await navigator.clipboard.writeText(text)
    } catch {
      return this.announce('Copy failed')
    }

    this.flashButton()
    this.announce('Copied to clipboard')
  }

  // Swap the button label to "Copied!" then restore it after a short beat.
  flashButton() {
    if (!this.hasButtonTarget) return

    const original = this.buttonTarget.dataset.label || this.buttonTarget.textContent
    this.buttonTarget.dataset.label = original
    this.buttonTarget.textContent = 'Copied!'

    clearTimeout(this.revert)
    this.revert = setTimeout(() => {
      this.buttonTarget.textContent = original
    }, 2000)
  }

  announce(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
  }
}
